export default {
  name: 'NumCon',
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  }
};